<style>
	.requirement-list li.story {
		border-left: 6px solid #82d467;
	}

	.requirement-list .description textarea {
		width: 100%;
		height: 80px;
		margin-top: 0.5rem;
	}

	.requirements-wrapper .toggle-send {
		cursor: pointer;
	}

	.notes {
		width: 100%;
		min-height: 900px;
		border: 0;
	}

	.notes-placeholder {
		width: 100%;
		min-height: 900px;
		text-align: center;
		padding-top: 420px;
	}
</style>

<template>
    <div class="container-fluid my-5">
        <div class="row">
            <div class="col-xl-8 mb-4">
                <div class="card">
                    <div class="notes-placeholder" v-show="!documentLoaded">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    </div>
                    <iframe v-show="documentLoaded" @load="driveLoaded()" class="notes" v-bind:src="project.google_notes_link+'&rm=demo'" sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"></iframe>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="card requirements-wrapper">
                    <div class="card-body">
                        <div class="row mb-1">
                            <div class="col d-flex align-items-center">
                                <h2 class="card-title mb-0">Requirements</h2>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-sm btn-link toggle-send" @click="sending = !sending" :title="sending ? 'Cancel' : 'Select requirements'">
                                    <i class="far" v-bind:class="{'fa-check-square': !sending, 'fa-times': sending}"></i>
                                </button>
                            </div>
                        </div>
                        <p class="small text-muted">Noted requirements that will be the basis of one or more user stories</p>

                        <div class="input-group mb-3">
                            <input type="text" v-model="newRequirement.title" placeholder="Add requirement" class="form-control" v-on:keyup.enter="addRequirement()">
                            <button type="button" class="btn btn-primary" v-on:click="addRequirement()"><i class="far fa-plus"></i> Add</button>
                        </div>

                        <div v-show="sending" class="d-flex justify-content-between mb-3">
                            <button type="button" class="btn btn-sm btn-light" @click="checkAll()">
                                <i class="far fa-check-double"></i> Select All
                            </button>

                            <button type="button" class="btn btn-sm btn-primary btn-create-userstories" @click="createUserStories()">
                                Create Userstories
                            </button>
                        </div>

                        <ul class="list-group requirement-list mb-3">
                            <template v-for="requirement in project.user_story_document.requirements">
                                <transition name="fade" v-bind:key="requirement.id">
                                    <single-requirement :requirement="requirement" :sending="sending"></single-requirement>
                                </transition>
                            </template>
                        </ul>

                        <recorder></recorder>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { notify } from 'utils'
    import Recorder from 'components/form/recording/recording.vue'
    import SingleRequirement from './requirement.vue'
	import requirement from './../../../models/requirement.js'
    
    export default {
        components: {
          SingleRequirement,
          Recorder
        },

    	props: ['project'],
        data: function () {
            return {
                loading: true,
                content: "",
                newRequirement: new requirement(),
                sending: false,
                send: false,
                lastSaved: new Date(),
                lastSent: "",
                lockNotes: true,
                saveNotesInterval: null,
                documentLoaded: false
            }
        },
        mounted: function() {

            var that = this;

            if (this.project.user_story_document.locked_by) {
				this.lockNotes = true;
			} else {
				this.lockNotes = false;
			}

			that.$bus.$on('notesLocked', function(locked) {
				that.lockNotes = locked
			});

			that.$bus.$on('window-closed', function() {
				that.notesActive(false);
			});

            that.$bus.$on('delete-requirement', function(id) {
                that.deleteRequirement(id)
            });
        },
        route: {
            
            data: function() {
                
            }
        },
        methods: {
        	driveLoaded: function() {
        		this.documentLoaded = true;
        	},
        	/**
        	* User is trying to focus on the notes field if active param is true, otherwise if false user is blur
        	*/
        	notesActive: function(active) {
        		var that = this;

        		if (!active) {
        			clearInterval(that.saveNotesInterval);
        			that.saveNotes();
        		} 
        			
    			if (that.lockNotes) {
    				if (this.project.user_story_document.locked_by) {
                		that.$swal('User Already Editing...', this.project.user_story_document.locked_by.name+' is currently editing this field!<br><br>Since: '+moment(this.project.user_story_document.locked_at).format('dddd Do MMMM YYYY, h:mm:ss a'), 'error');
    				}
        		} else {
        			//Attempt to lock the notes
        			return client({path: '/user-story-document/'+this.project.user_story_document_id+'/notes/lock', entity: {active: active}, method: 'POST'}).then(
	                    function(response) {

	                        if (response.entity.status == 'locked') {
	                        	that.lockNotes = true;
	                        	that.$swal('User Already Editing...', response.entity.user.name+' is currently editing this field!', 'error');
	                        } else {
	                        	that.lockNotes = false;

	                        	//If user has just locked the field then start the auto save
	                        	if (active) {
		                        	that.saveNotesInterval = setInterval(function () {
						              that.saveNotes();
						            }.bind(this), 5000);
	                        	}
	                        }
	                    },
	                    function(response) {
	                        
	                    }
	                );
        		}
        	},
            saveNotesManual: function() {
                return this.saveNotes(true)
            },
            saveNotes: function(force = false) {
                var that = this;

                if (this.lastSent === this.project.user_story_document.notes && force === false) { return }

                return client({path: '/user-story-document/'+this.project.user_story_document_id, entity: { notes: this.project.user_story_document.notes}, method: 'PUT'}).then(
                    function(response) {
                        that.newRequirement = new requirement();
                        that.lastSent = that.project.user_story_document.notes
                        that.lastSaved = new Date()
                    },
                    function(response) {
                        
                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                            
                        } else {
                            
                        }
                    }

                )
            },
            addRequirement: function() {
            	var that = this;

            	return client({path: '/user-story-document/'+this.project.user_story_document_id+'/requirements', entity: this.newRequirement, method: 'POST'}).then(
                    function(response) {
                    	that.newRequirement = new requirement();
                    	that.project.user_story_document.requirements.push(response.entity);
                    },
                    function(response) {
                        
                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                            
                        } else {
                            
                        }
                    }

                )
            },
            
            deleteRequirement (id) {
                this.project.user_story_document.requirements.splice(this.project.user_story_document.requirements.findIndex(x => x.id === id), 1);
            },

            checkAll: function() {
            	this.send = !this.send;

            	for (var i=0;i<this.$children.length;i++) {
            		if (this.$children[i].requirement != undefined && this.$children[i].requirement.story_id == null) {
            			this.$children[i].send = this.send;
            		}
            	}
            },
            createUserStories: function() {
                var that = this
                var requirementIds = []

            	for (var i=0;i<this.$children.length;i++) {
                    var child = this.$children[i]

            		if (child.send == true) {
                        requirementIds.push(child.requirement.id)
                    }
            	}

                if (requirementIds.length > 0) {
                    client({path: '/user-story-document/'+this.$parent.project.user_story_document_id+'/requirements/create-stories', entity: {requirement_ids: requirementIds}, method: 'POST'}).then(
                        function(response) {

                            for (var i=0;i<that.project.user_story_document.requirements.length;i++) {
                                var requirement = that.project.user_story_document.requirements[i]
                                var newRequirement = $.grep(response.entity, function(e){ return e.id == requirement.id; });
                                
                                if (newRequirement.length > 0) {
                                    // that.project.user_story_document.requirements[i] = newRequirement[0]
                                    Vue.set(that.project.user_story_document.requirements, i, newRequirement[0])
                                }
                            }
                        },
                        function(reasponse) {
                            notify.error('Failed to create User Stories')
                        }
                    )
                }
            }
        },
        filters: {
		    marked: function (md) {
		      return marked(md, { sanitize: true })
		    }
		}
    }
</script>